// components/FinalCTA.jsx
import React from "react";
import { Link } from "react-router-dom";
import styles from "../Info.module.css";

const FinalCTA = () => {
  return (
    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <div className={styles.finalCta}>
          <div className={styles.finalGlow}></div>
          <span className={styles.finalBadge}>
            <i className="fas fa-bolt"></i>
            شروع همینی
          </span>
          <h2 className={styles.finalTitle}>زبان رو دیگه حفظ نکن — یاد بگیر</h2>
          <p className={styles.finalNote}>
            با اشتراک UmLang همه ویژگی‌ها رو قفل‌گشایی کن؛ با تخفیف و پشتیبانی
            کامل فارسی‌زبان.
          </p>
          <Link to="/Subscription" className={styles.ctaPrimary}>
            <i className="fas fa-play icon-start"></i>
            شروع یادگیری
          </Link>
          <p className={styles.finalSmall}>
            <i className="fas fa-shield-alt"></i>
            ضمانت بازگشت وجه — اگه راضی نبودی، پولت برمی‌گرده.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;